var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg107PanicButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.667,
    height: 451.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 378.667,
    height: 378.667,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    ry: 213.823,
    rx: 213.741,
    id: "svg_5",
    cy: 225.795,
    cx: 224.459,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 51.829,
    rx: 50.775,
    id: "svg_1",
    cy: 132.703,
    cx: 242.03,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f03",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2",
    height: 62.869,
    width: 39.058,
    y: 275.693,
    x: 211.61,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_3",
    height: 62.869,
    width: 39.058,
    y: 261.125,
    x: 198.09,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_4",
    height: 236.144,
    width: 39.058,
    y: 120.053,
    x: 222.125,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_6",
    height: 247.644,
    width: 39.058,
    y: 189.822,
    x: 261.934,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_7",
    height: 247.644,
    width: 39.058,
    y: 189.056,
    x: 237.899,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_8",
    height: 231.543,
    width: 39.058,
    y: 204.39,
    x: 307.752,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_9",
    height: 236.144,
    width: 39.058,
    y: 202.09,
    x: 273.201,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_10",
    height: 128.039,
    width: 39.058,
    y: 295.627,
    x: 325.779,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_11",
    height: 62.869,
    width: 39.058,
    y: 234.291,
    x: 332.539,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#193351",
    id: "svg_12",
    d: "m354.742104,221.201024c-0.000781,0 -0.000781,0 -0.001562,0l0,-0.000797c0,-15.833338 -12.61418,-28.709237 -28.125685,-28.709237c-5.7884,0 -11.172158,1.794078 -15.648208,4.864742c-3.847216,-11.181492 -14.286645,-19.21976 -26.540711,-19.21976c-5.121288,0 -9.92152,1.410544 -14.061671,3.860059l0,-46.924313c0,-15.833338 -12.61418,-28.709237 -28.125685,-28.709237c-15.511505,0 -28.125685,12.8759 -28.125685,28.709237l0,115.559364c-16.023946,3.333795 -28.126467,17.828353 -28.126467,35.164729c0,20.025101 7.383529,39.130837 20.79918,53.787261c13.796077,15.072649 21.389738,34.350617 21.389738,54.33266l0,21.072843c0,8.039065 4.219048,19.235707 24.371428,26.800338c12.249378,4.593637 28.562353,7.134052 45.943957,7.134052c32.443159,0 70.314604,-8.88587 70.313823,-33.933592l0,-37.609459c0,-9.947964 1.2522,-20.484385 3.811283,-32.197722c6.792191,-31.220947 10.251951,-63.275142 10.251951,-95.271928c0,-15.833338 -12.61418,-28.709237 -28.125685,-28.709237l0,-0.000001l-0.000001,-0.000002zm4.133901,120.865848c-2.784838,12.746725 -4.134682,24.287832 -4.134682,35.312242l0,37.609459c0,10.794769 -25.229142,19.580171 -56.251371,19.580171s-56.251371,-8.785401 -56.251371,-19.580171l0,-21.072843c0,-23.628408 -8.944289,-46.409213 -25.186959,-64.15145c-10.954995,-11.971684 -17.001959,-27.57538 -17.001959,-43.96847c0,-9.35552 5.879796,-17.333984 14.063233,-20.297004l0,27.474114l14.061671,0l0,-157.901203c0,-7.924244 6.314901,-14.355017 14.063233,-14.355017c7.749113,0 14.063233,6.43157 14.063233,14.355017l0,71.742394c0,0.010366 -0.000781,0.020732 -0.000781,0.031097l0.000781,0l0,28.709237l14.063233,0l0,-28.724388c0.008593,-7.917068 6.318808,-14.339867 14.062452,-14.339867c7.749113,0 14.063233,6.43157 14.063233,14.355017l0,14.32392c0,0.010366 -0.000781,0.020732 -0.000781,0.031097l0.000781,0l0,14.35422l14.061671,0l0,-14.35422l0.000781,0c0,-7.924244 6.314901,-14.355017 14.063233,-14.355017c7.749113,0 14.063233,6.43157 14.063233,14.355017l0,28.709237l14.061671,0l0,-14.266509c7.277291,0.198545 14.064015,6.389311 14.064015,14.266509c0,30.934691 -3.347273,61.955498 -9.928551,92.157409l-0.000001,0l0.000002,0.000002z",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f03",
    id: "svg_13",
    d: "m143.798293,135.071718c0,-55.394754 44.157443,-100.482729 98.440289,-100.482729s98.440289,45.087974 98.440289,100.482729c0,9.115512 -1.181896,18.129758 -3.544125,26.800338l13.557041,3.818596c2.686412,-9.919258 4.050318,-20.211685 4.050318,-30.618934c0,-63.318998 -50.472345,-114.837745 -112.503523,-114.837745s-112.503523,51.518748 -112.503523,114.836948c0,32.613948 13.669528,63.806987 37.4918,85.568756l9.380176,-10.67915c-20.855424,-19.049123 -32.808743,-46.351803 -32.808743,-74.888809l0.000001,0z",
    stroke: "null"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg107PanicButton);
export default __webpack_public_path__ + "static/media/107 Panic Button.4178621eba10627fc32193aef2cc4bfb.svg";
export { ForwardRef as ReactComponent };